import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { studio } from '@/data/studio';
import { Logo } from './Logo';

export function Footer() {
  const { t } = useTranslation();
  const year = '2026';

  return (
    <footer className="relative mt-px bg-ink text-paper">
      <div className="u-container py-24">
        {/* Brand line */}
        <div className="mb-16 border-b border-white/10 pb-14">
          <Logo className="h-14 md:h-20" />
        </div>

        <div className="grid gap-x-16 gap-y-14 md:grid-cols-[1.6fr_1fr_1fr]">
          <p className="max-w-sm text-lg leading-relaxed text-paper/70">{t('footer.tagline')}</p>

          <nav className="flex flex-col gap-4 text-lg">
            <p className="eyebrow mb-3 text-paper/40">{t('footer.explore')}</p>
            <Link to="/lavori" className="link-line w-fit">
              {t('nav.work')}
            </Link>
            <Link to="/design" className="link-line w-fit">
              {t('nav.design')}
            </Link>
            <Link to="/studio" className="link-line w-fit">
              {t('nav.studio')}
            </Link>
            <Link to="/contatti" className="link-line w-fit">
              {t('nav.contact')}
            </Link>
          </nav>

          <div className="flex flex-col gap-4 text-lg">
            <p className="eyebrow mb-3 text-paper/40">{t('footer.contact')}</p>
            <a href={`mailto:${studio.email}`} className="link-line w-fit">
              {studio.email}
            </a>
            <a href={`tel:${studio.phoneHref}`} className="link-line w-fit">
              {studio.phone}
            </a>
            <a href={studio.whatsapp} target="_blank" rel="noopener noreferrer" className="link-line w-fit">
              WhatsApp
            </a>
            <p className="mt-2 max-w-xs text-base leading-relaxed text-paper/55">{studio.address}</p>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="u-container flex flex-col gap-4 py-8 text-sm text-paper/45 md:flex-row md:items-center md:justify-between">
          <p>© {year} Watermelon Studio · P. IVA {studio.vat}</p>
          <p>
            {t('footer.credit')}{' '}
            <a
              href="https://watermelon-studio.it"
              target="_blank"
              rel="noopener noreferrer"
              className="link-line text-paper/75"
            >
              Watermelon
            </a>
          </p>
          <Link to="/privacy" className="link-line">
            Privacy
          </Link>
        </div>
      </div>
    </footer>
  );
}
